import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../../common/components/button/Button'
import { getIcon } from '../../../../common/components/icons/utils'
import styles from './AddMembersModal.module.css'

export type AddPlayersPreviewProps = {
  onClose: () => void
  onSubmit: () => void
  onBack: () => void
  message: string
}

export const AddPlayersPreview: React.FC<AddPlayersPreviewProps> = ({ onClose, onSubmit, onBack, message }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={classNames(styles.iconRow)} onClick={onBack}>
        <span className={classNames(styles.icon)}>{getIcon('arrowLeft')}</span>
        <span>{t('common.back')}</span>
      </div>

      <div className={classNames(styles.description, 'medium')}>
        {t(
          'settings_organization.players.add_players.email_description',
          'This email will be send to the players you invited:',
        )}
      </div>

      <div className={styles.mainFormContainerpreview}>
        <div className={styles.userInfoContainer} dangerouslySetInnerHTML={{ __html: message }} />
      </div>

      <div className={styles.footer}>
        <Button variant='outline-normal' onClick={onClose}>
          {t('settings_organization.members.add_members.button_text.cancel', 'Cancel')}
        </Button>
        <Button onClick={onSubmit}>
          {getIcon('email')}
          {t('settings_organization.members.add_members.button_text.send_invites', 'Send invites')}
        </Button>
      </div>
    </>
  )
}
